/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook";
import { AllSportsList } from "../../../redux/Slice/Sports/SportsListSlice";
import { AddCoachingBookingDetails } from "./AddCoachingBookingDetails";
import { CoachBooking } from "./CoachBooking";
import { CoachingBookingSummary } from "./CoachingBookingSummary";
import { GetSportsDetails } from "../../../utilities/api/sports/indext";
import {
  GetAvailableSessions,
  GetSessionDetails,
} from "../../../utilities/api/session";
import { CreateNewCoachBooking } from "../../../utilities/api/coachingBooking";
import { format } from "date-fns";
import { toast } from "react-toastify";

import "./AddNewCoachingSession.css";
import { countWeeks } from "../../Coaching/session.utils";
import { emailValidation, nameValidation } from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.coachingSessionBooking;

const AddNewCoachingSession = () => {
  const dispatch = useAppDispatch();
  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);
  const { SelectedFacility = "" } = useAppSelector(
    (state) => state.facilityList
  );
  const [summaryBooking, setSummaryBooking] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [AllSessionsData, setAllSessionData] = useState([]) as any;
  const [data, setData] = useState({
    sportId: "",
    slotDate: "",
    sessionId: "",
    phone: "",
    schoolName: "",
    firstName: "",
    lastName: "",
    parentName: "",
    gender: "",
    whatsAppNumber: "",
    birthDate: "",
    aadharNumber: "",
    image: "" as any,
    haveIdProof: "",
    gstNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    landmark: "",
    latitude: "",
    longitude: "",
    isIgstTax: "",
    noOfSessionToAttend: "",
    selectedSlots: [],
    discount: "",
    paymentMode: "",
    paymentMethod: "",
    startDate: "",
    noOfDays: "",
    noOfWeeks: "",
  });

  const [sportData, setSportData] = useState<any>({});
  const [sessionData, setSessionData] = useState<any>({});
  const [verifyButton, setVerifyButton] = useState(false);
  const [verifiedUser, setVerifiedUser] = useState({}) as any;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    gender: "",
    birthDate: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    email: "",
    image: "",
  });
  if (sportErrorMessage) {
    toast.error(sportErrorMessage.message)
  }
  useEffect(() => {
    if (data?.sportId && data?.noOfDays) {
      setIsLoading(true);
      GetAvailableSessions(SelectedFacility, data?.sportId, `${data?.noOfDays}`)
        .then((res: any) => {
          setAllSessionData(res?.data?.rows);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || getMessage.something_wrong);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [data?.sportId, data?.noOfDays]);

  useEffect(() => {
    handleUpdate("sessionId", null);
    handleUpdate("sportId", "");
    handleUpdate("startDate", "");
    handleUpdate("selectedSlots", []);
    setSportData({});
    dispatch(AllSportsList({ facilityId: SelectedFacility, isActive: "true" }));
    if (SelectedFacility === "") {
      toast.error(getMessage.facility_select);
    }
  }, [SelectedFacility]);

  useEffect(() => {
    handleUpdate("sessionId", "");
    handleUpdate("startDate", "");
    setSessionData({});
    if (data?.sportId) {
      setIsLoading(true);
      GetSportsDetails(data?.sportId)
        ?.then((res: any) => {
          setSportData(res?.data);
        })
        ?.catch((error) => toast.error(error.message))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [data?.sportId]);

  useEffect(() => {
    handleUpdate("startDate", "");
    if (data?.sessionId) {
      GetSessionDetails(data?.sessionId)
        ?.then((res: any) => {
          setSessionData(res?.data);
        })
        ?.catch((error) => toast.error(error.message));
    }
  }, [data?.sessionId]);

  const handleNext = () => {
    if (currentStep === 0 && !isStepOneValid()) {
      return false;
    }
    if (currentStep === 1 && !isStepTwoValid()) {
      return false;
    }

    setCurrentStep((_oldVal) => {
      if (_oldVal < 2) {
        return ++_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  const handleUpdate = (key: any, value: any) => {
    if (typeof key === "object") {
      setData((_oldData) => ({ ..._oldData, ...key }));
    } else {
      setData((_oldData) => ({ ..._oldData, [key]: value }));


      setError((prevError) => ({ ...prevError, [key]: "" }));
    }
  };

  const getIsDisabled = () => {
    if (currentStep === 0) {
      return !data?.sportId || !data?.sessionId || !data?.startDate;
    }
    if (currentStep === 1) {
      return !data?.paymentMethod || !verifyButton;
    }
    return false;
  };

  const isStepOneValid = () => {
    if (data?.selectedSlots?.length < Number(data?.noOfDays)) {
      toast.error(
        `Number of selected slots are less than selected number of days per week. Select at least ${data?.noOfDays} slots.`
      );
      return false;
    }
    if (data?.noOfWeeks < sessionData?.minWeeksToBook) {
      toast.error(
        `Selected Weeks are less than the minimum number of weeks to book. Please select at least ${sessionData?.minWeeksToBook} week(s).`
      );
      return false;
    }
    if (
      Number(data?.noOfWeeks) >
      countWeeks(
        new Date(),
        new Date(sessionData.endDate?.split("/").reverse().join("/"))
      )
    ) {
      toast.error(
        `Selected Weeks are more than the maximum number of weeks that can be booked. Please select between ${sessionData?.minWeeksToBook
        } to ${countWeeks(
          new Date(),
          new Date(sessionData.endDate?.split("/").reverse().join("/"))
        )} weeks.`
      );
      return false;
    }
    if (
      Number(data?.noOfWeeks) >
      countWeeks(
        new Date(format(new Date(data.startDate), "yyyy/MM/dd")),
        new Date(sessionData.endDate?.split("/").reverse().join("/"))
      )
    ) {
      toast.error(
        `Selected Weeks are more than the available weeks to book. Please select between ${sessionData?.minWeeksToBook
        } to ${countWeeks(
          new Date(format(new Date(data.startDate), "yyyy/MM/dd")),
          new Date(sessionData.endDate?.split("/").reverse().join("/"))
        )} weeks.`
      );
      return false;
    }
    if (SelectedFacility === "") {
      toast.error(getMessage.facility_select);
      return false;
    }

    return true;
  };
  const validImageTypes = ["image/png", "image/jpeg"];
  const maxImageSize = 5 * 1048576;

  const isValidImage = (image: any) => {
    if (!image || image === "") return true; // optional field
    if (typeof image === "string") return true; // server URL
    return validImageTypes.includes(image.type) && image.size <= maxImageSize;
  };
  const isStepTwoValid = () => {
    return (
      data?.phone?.length === 10 &&
      data?.firstName?.length >= 3 &&
      data?.firstName?.length <= 16 &&
      nameValidation(data?.firstName) != null &&
      data?.lastName?.length >= 1 &&
      data?.lastName?.length <= 16 &&
      nameValidation(data?.lastName) != null &&
      data?.birthDate &&
      data?.addressLine2.length <= 50 &&
      data?.landmark.length <= 50 &&
      (data.email == "" || emailValidation(data.email) != null) &&
      isValidImage(data?.image)
    );
  };

  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  const submit = async () => {
    if (isStepOneValid() && isStepTwoValid()) {
      const bodyFormData = new FormData();
      bodyFormData.append("sessionId", data?.sessionId);
      bodyFormData.append("phone", data?.phone);
      bodyFormData.append("schoolName", data?.schoolName || "");
      bodyFormData.append("firstName", data?.firstName);
      bodyFormData.append("lastName", data?.lastName);
      bodyFormData.append("parentName", data?.parentName || "");
      bodyFormData.append("gender", data?.gender || "");
      bodyFormData.append("whatsAppNumber", data?.whatsAppNumber || "");
      bodyFormData.append(
        "birthDate",
        data?.birthDate &&
        format(getFormatedDate(data?.birthDate), "yyyy-MM-dd") || ""
      );
      bodyFormData.append("aadharNumber", data?.aadharNumber || "");
      bodyFormData.append("email", data?.email || "");
      bodyFormData.append("image", data?.image || "");
      bodyFormData.append("haveIdProof", data?.haveIdProof || "false");
      bodyFormData.append("gstNumber", data?.gstNumber || "");

      bodyFormData.append("addressLine1", data?.addressLine1 || "");
      bodyFormData.append("addressLine2", data?.addressLine2 || "");
      bodyFormData.append("city", data?.city || "");
      bodyFormData.append("state", data?.state || "");
      bodyFormData.append("country", data?.country || "India");
      bodyFormData.append("pincode", data?.pincode || "");
      bodyFormData.append("landmark", data?.landmark || "");
      bodyFormData.append("latitude", data?.latitude || "");
      bodyFormData.append("longitude", data?.longitude || "");
      bodyFormData.append("isIgstTax", data?.isIgstTax || "false");
      bodyFormData.append("noOfWeeks", data?.noOfWeeks + "");
      bodyFormData.append("noOfDays", data?.noOfDays + "");
      bodyFormData.append(
        "selectedSlots",
        JSON.stringify(data?.selectedSlots.map((item: any) => item.value) || [])
      );
      bodyFormData.append("discount", data?.discount || "");
      bodyFormData.append("paymentMode", "instant");
      bodyFormData.append("paymentMethod", data?.paymentMethod);
      bodyFormData.append(
        "startDate",
        format(new Date(data?.startDate), "yyyy-MM-dd")
      );

      setIsLoading(true);
      const result = await CreateNewCoachBooking(bodyFormData);
      if (result.status === 200) {

        setSummaryBooking(result.data.data.id);
        handleNext();
        toast.success(result.data.message);
      } else {
        toast.error(result.response.data.message);
      }
      setIsLoading(false);
    } else if (!isStepTwoValid()) {
      setError({
        phone:
          data?.phone?.length === 10
            ? ""
            : getMessage.phone_maxLength,
        firstName:
          data?.firstName?.length < 3 || data?.firstName?.length > 30
            ? getMessage.firstName_min_max
            : nameValidation(data?.firstName) == null
              ? getMessage.firstName_matches
              : "",
        lastName:
          data?.lastName?.length < 1 || data?.lastName?.length > 30
            ? getMessage.lastName_min_max
            : nameValidation(data?.lastName) == null
              ? getMessage.lastName_matches
              : "",
        // gender: data?.gender ? "" : getMessage.gender_required,
        gender: data?.gender ? "" : "",
        birthDate: data?.birthDate ? "" : getMessage.dateOfBirth_required,

        addressLine1: data?.addressLine1
          ? data?.addressLine1.length > 50
            ? getMessage.addressLine1_maxLength
            : ""
          : "",
        addressLine2:
          data?.addressLine2.length > 50
            ? getMessage.addressLine2_maxLength
            : "",
        landmark:
          data?.landmark.length > 50
            ? getMessage.landmark_maxLength
            : "",
        city: data?.city
          ? data?.city.length > 50
            ? getMessage.city_maxLength
            : ""
          : "",
        state: data?.state ? "" : "",
        pincode: data?.pincode?.length === 6 ? "" : "",
        email:
          data.email == ""
            ? getMessage.email_required
            : emailValidation(data.email)
              ? ""
              : getMessage.email_matches,
        image:
          data.image == "" || typeof data.image === "string"
            ? ""
            : !validImageTypes.includes(data?.image?.type)
              ? getMessage.image_match_type
              : data?.image?.size > maxImageSize
                ? getMessage.image_size
                : "",
      });
    }
  };

  return (
    <>
      <Container
        fluid
        className="g-0"
        style={
          isLoading
            ? {
              pointerEvents: "none",
              opacity: 0.7,
            }
            : {}
        }
      >
        <Card>
          <Card.Body>
            {currentStep !== 0 && currentStep !== 2 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {currentStep === 0 && (
              <CoachBooking
                allSportsData={AllSportsData}
                allSessionsData={AllSessionsData}
                updateData={handleUpdate}
                data={data}
                sessionData={sessionData}
                sportData={sportData}
              />
            )}
            {currentStep === 1 && (
              <AddCoachingBookingDetails
                updateData={handleUpdate}
                data={data}
                sessionData={sessionData}
                verifiedUser={verifiedUser}
                setVerifiedUser={setVerifiedUser}
                error={error}
                setError={setError}
                setVerifyButton={setVerifyButton}
                verifyButton={verifyButton}
              />
            )}
            {currentStep === 2 && (
              <CoachingBookingSummary
                data={data}
                summaryBooking={summaryBooking}
                sessionData={sessionData}
                sportData={sportData}
              />
            )}
            <hr />
            {currentStep < 2 && (
              <Row>
                <Col className="text-end">
                  <Button
                    type="button"
                    bname={currentStep === 1 ? "Submit" : "Next"}
                    name="next"
                    id="next"
                    className="btn btn-primary rounded-1"
                    onClick={currentStep === 1 ? submit : handleNext}
                    disabled={getIsDisabled()}
                  ></Button>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      </Container>
      {isLoading && <div className="loader">Loading...</div>}
    </>
  );
};

export { AddNewCoachingSession };
